<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 渠道管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="120px" @keyup.enter.native="search()">
          <el-row>

            <el-col :span="6">
              <el-form-item label="经销商编码" prop="dealerCode">
                <el-input v-model.trim="searchform.dealerCode" style="width:100%" clearable placeholder="请输入经销商编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="终端编码" prop="receiveCode">
                <el-input v-model.trim="searchform.receiveCode" style="width:100%" clearable placeholder="请输入终端编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-input v-model.trim="searchform.productCode" style="width:100%" clearable placeholder="请输入产品编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据编号" prop="outCode">
                <el-input v-model.trim="searchform.outCode" style="width:100%" clearable placeholder="请输入单据编号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="orderType">
                <el-select v-model="searchform.orderType" placeholder="请选择">
                  <el-option label="所有" :value="null"></el-option>
                  <el-option label="扫码出库" :value="0"></el-option>
                  <el-option label="扫码退货" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="searchform.page = 1; search()">搜索</el-button>
              <Uploadexcel :uploadurl="actionurl" :search="search" :searchform="searchform" />

            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{ $route.meta.title }}</h4>
          <el-divider />
          <el-table id="parent" v-loading="listLoading" border element-loading-text="拼命加载中" :data="tableData"
            style="width:100%;">
            <af-table-column v-for="item in TBheaders" :key="item.prop" :prop="item.prop" :label="item.label"
              min-width="200">
            </af-table-column>
          </el-table>
          <br />
          <el-pagination background :current-page.sync="searchform.page" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count" @current-change="currentchange"
            @size-change="limitchange" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  findOutOrderPage,
} from "@/api/market/channel";
import Uploadexcel from "@/components/Upload/Uploadexcel";

// 引入导出组件模块
export default {
  name: "Freight",
  components: { Uploadexcel },
  data() {
    return {
      // 导入导出参数
      actionurl: {
        uploadingurl: '',
        downloadurl: process.env.VUE_APP_BASE_API +
          "/api/out/report/orderOut/findOutOrderList",
        hrefurl: ""
      },
      // 基础数
      listLoading: false,
      tableData: [],
      // 分页数据
      limits: "",
      total_count: 1,
      currentPage: 1,
      // 搜索表单数据
      TBheaders: [
        { prop: "dealerName", label: "经销商名称" },
        { prop: "orderType", label: "出库类型" },
        { prop: "outBillCode", label: "工单号" },
        { prop: "productName", label: "产品" },
        { prop: "receiveCode", label: "终端编码" },
        { prop: "receiveName", label: "终端" },
        { prop: "planQuantity", label: "计划数量" },
        { prop: "scanQuantity", label: "扫码数量" },
        { prop: "unitName", label: "出库单位名称" },
      ],
      searchform: {
        orderType: null,
        dealerName: null,
        page: 1,
        limit: 10
      }
    };
  },
  mounted() {
    // 请求部门列表数据并且便利到表格
    console.log(this.$route.meta.title)
    this.search();
  },
  methods: {
    // 新增物料分类
    addstore() {
      this.$refs.mychild.form = {

        "categoryCode": "",
        "categoryName": "",
        "categoryParentId": "",
        "orgCode": "",
        "status": 1,
        "remark": "",
        "description": ""
      };
      this.$refs.mychild.title = '新增物料分类';
      this.$refs.mychild.show = true;
    },
    getoutbilldata(row) {
      console.log(row)

      document.getElementById("A1").scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
      const obj = row;
      this.$refs.mychild.form = Object.assign({}, obj);
      this.$refs.mychild.title = '修改物料分类';
      this.$refs.mychild.show = true;

    },
    // 请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      findOutOrderPage(obj).then(response => {
        this.tableData = response.data.list;
        console.log(response.data);
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.page;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) { }
    },
    // 搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.Tabledata({
        categoryCode: this.searchform.categoryCode,
        categoryName: this.searchform.categoryName,
        page: this.searchform.page,
        limit: this.searchform.limit
      });
    },
    // 分页每页显示条数事件
    limitchange(limit) {
      this.searchform.limit = limit;
      this.search();
    },
    // 跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped></style>
